import React from 'react';
import './index.css';

function Integrations() {
  return (
    <section className="detail-page">
      <div className="detail-container">
        <h1 className="detail-title">
          Seamless <span className="detail-gradient">Integrations</span>
        </h1>

        <div className="detail-intro">
          <p>
            Integrations can take your ERP to the next level by allowing a third party software to push data into, or extract data out of your ERP system.
            Any data pushed into your ERP system should be safely executed by using Business Logic. Many times, inexperienced integrators will,
            based on their knowledge of SQL and the ERP schema, attempt to directly enter data using SQL but this more often than not will cause issues with your data integrity.
          </p>
        </div>

        <div className="detail-grid">
          <div className="detail-card">
            <div className="detail-card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <polyline points="16 18 22 12 16 6"/>
                <polyline points="8 6 2 12 8 18"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Implemented Integrations</h2>
            <ul className="detail-list detail-list-compact">
              <li>Bartender (FileDrop and Webservice)</li>
              <li>Advanced Requisitions Management (ARM)</li>
              <li>Epicor Content Management (ECM\DocStar)</li>
              <li>Epicor Intelligent Data Capture (IDC\OCR)</li>
              <li>SMART Forecasting</li>
              <li>ADP TimeKeeping</li>
              <li>Payserv HR</li>
              <li>Concept One shop</li>
              <li>Salesforce CRM</li>
              <li>Active Directory\Azure\Entra</li>
              <li>Microsoft Project</li>
              <li>Barcode and RFID readers</li>
              <li>Artificial Intelligence (AI)</li>
            </ul>
          </div>

          <div className="detail-card detail-card-accent">
            <div className="detail-card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Tools</h2>
            <ul className="detail-list">
              <li>Custom C# Development</li>
              <li>Automation Studio</li>
              <li>Workato</li>
              <li>Epicor SDK</li>
              <li>Service Connect</li>
              <li>EFT\SEPA\ACH\PositivePay Electronic Payments</li>
            </ul>
          </div>

          <div className="detail-card">
            <div className="detail-card-icon detail-icon-purple">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Additional Skills</h2>
            <ul className="detail-list">
              <li>Bartender Label Design</li>
              <li>SSRS and Crystal Reports</li>
              <li>Image Editing and Icon Creation</li>
              <li>Video Capture and Video Editing</li>
              <li>Sound Design and Editing</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Integrations;
